import classNames from "classnames";
import React from "react";
import styles from "./StatusPulse.scss";

/**
 * Small dot with a pulsing ring, to draw attention to a status, e.g. a task that is past due
 * @param color – "error", "warning" or "success"
 * @param spaced – space after the dot, when it is placed in front of text
 */
export const StatusPulse = ({ color = "error", spaced, className }) => {
    return (
        <span
            className={classNames(styles.base, styles[color], { [styles.spaced]: spaced }, className)}
            aria-hidden="true"
        />
    );
};
